import {APIPlatformSerializer} from './abstract';

export class RoleSerializer extends APIPlatformSerializer {
  base = '/roles';
}
